function basePalette(variables, mode) {
    return {
        mode,
        common: {
            white: variables.surface,
            black: variables.text_primary,
        },
        background: {
            default: variables.surface_canvas,
            paper: variables.surface,
        },
        divider: variables.border_subtle,
        action: {
            active: variables.text_medium,
            hover: variables.surface_hover,
            selected: variables.surface_selected,
            disabled: variables.text_disabled,
            disabledBackground: variables.surface_disabled,
            focus: variables.surface_hover,
        },
        primary: {
            main: variables.text_primary,
        },
        secondary: {
            main: variables.text_primary,
        },
        info: {
            main: variables.text_medium,
        },
        success: {
            main: variables.feedback_success,
        },
        warning: {
            main: variables.feedback_warning,
        },
        error: {
            main: variables.feedback_danger,
        },
        malicious: {
            main: variables.analysis_fail,
        },
        suspicious: {
            main: variables.analysis_warn,
        },
        goodware: {
            main: variables.analysis_pass,
        },
        unknown: {
            main: variables.analysis_none,
        },
        valid: {
            main: variables.text_primary,
        },
        highSeverity: {
            main: variables.severity_high,
        },
        mediumSeverity: {
            main: variables.severity_medium,
        },
        lowSeverity: {
            main: variables.severity_low,
        },
        text: {
            primary: variables.text_primary,
            secondary: variables.text_medium,
            disabled: variables.text_disabled,
        },
    };
}
export function lightPalette({ variables }) {
    return basePalette(variables, "light");
}
export function darkPalette({ variables }) {
    return basePalette(variables, "dark");
}
export default lightPalette;
//# sourceMappingURL=palette.js.map